export default "__VITE_ASSET__BHsiLQY2__"